import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import { Text } from 'library';
import { Availability } from './CalendarAvailability';
import TwoWeekAvailabilityGrid from './TwoWeekAvailabilityGrid';
import moment from 'moment';

export default function TwoWeekAvailability({ availability }: { availability: Availability[] }) {
    const [monthLabel, setMonthLabel] = useState<string>('');

    useEffect(() => {
        if (availability && availability?.length) {
            const calDate = moment(availability[0].date + 'T10:00:00.000Z');
            setMonthLabel(calDate.format('MMMM YYYY'));
        }
    }, [availability]);

    return (
        <Grid container direction="column" style={{ marginTop: 40, overflow: 'scroll' }}>
            <Grid item>
                <Text variant="body1" bold>
                    {monthLabel}
                </Text>
            </Grid>
            <Grid item>
                <Text variant="body2">2-week availability</Text>
            </Grid>
            <Grid item container style={{ width: 310 }} justify="flex-end">
                <TwoWeekAvailabilityGrid availability={availability} />
            </Grid>
        </Grid>
    );
}
